import { defineMessages } from "react-intl"

export const vehicleDetailsMessages = defineMessages({
	editDisabledHint: {
		defaultMessage: "You can only edit one stage at a time.",
		id: "vehicleDetails.editingDisabled.hint",
	},
})
